import React, { useMemo }  from 'react'
import DropDown from '../dropdown';
import { GetPricingTypes } from '../../../api/services/pms';

const PricingTypesDropDown = ({...props}) => {
    const spec = useMemo(()=>{
        return {}
    }, [])
    return <DropDown search api={GetPricingTypes} spec={spec} textField="Name" valueField="Id" {...props}/>
}

export default PricingTypesDropDown